export default __webpack_public_path__ + "static/media/CH.57b6f52f.svg";